import styled from "styled-components";
import Flex from "../../layout/flex/Flex";

export const HeaderDiv = styled(Flex)`
  width: calc(100% + 8px);
  height: 72px;
  z-index: 1000;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 24px;
`;

export const HeaderLogo = styled(Flex)`
  flex: 1;
  justify-content: center;
`;

export const HeaderButton = styled.div`
  height: 20px;
  margin-bottom: -3px;
  flex-basis: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;
